<template>
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12">
      <UnpaidCustomers :items-per-page="5" />
    </div>
    <div class="col-lg-12 col-md-12 col-sm-12 mt-3">
      <NewCustomers :items-per-page="5" />
    </div>
  </div>
</template>
<script>
import UnpaidCustomers from '@views/admin/unpaidcustomers/view';
import NewCustomers from '@views/admin/customers/viewnewcustomers';

export default {
  name: 'AccountantDashboard',
  components: {
    UnpaidCustomers,
    NewCustomers,
  }
};
</script>
<style scoped>

</style>
